export interface MarketValueHistoryPoint {
  marketValue: number;
  validUntil?: string | null;
}

interface ChartPoint {
  timestamp: number;
  marketValue: number;
}

const CHART_LOOKBACK_MONTHS = 5;

const floorToReadableAxisValue = (value: number) => {
  if (value <= 0) return 0;
  if (value < 100) return Math.floor(value / 10) * 10;
  if (value < 1000) return Math.floor(value / 50) * 50;

  return Math.floor(value / 100) * 100;
};

const buildYAxisDomain = (data: ChartPoint[]) => {
  if (data.length === 0) return [0, 0] as [number, number];

  const values = data.map((point) => point.marketValue);
  const minValue = Math.min(...values);
  const maxValue = Math.max(...values);

  return [floorToReadableAxisValue(minValue / 2), maxValue] as [number, number];
};

export const buildMarketValueChartData = (
  history: MarketValueHistoryPoint[],
  now: Date = new Date()
) => {
  const start = new Date(now);
  start.setMonth(start.getMonth() - CHART_LOOKBACK_MONTHS);

  const data = history
    .map((point): ChartPoint => ({
      timestamp: point.validUntil ? new Date(point.validUntil).getTime() : now.getTime(),
      marketValue: point.marketValue,
    }))
    .filter((point) => point.timestamp >= start.getTime() && point.timestamp <= now.getTime())
    .sort((a, b) => a.timestamp - b.timestamp);

  return {
    data,
    xDomain: [start.getTime(), now.getTime()] as [number, number],
    yDomain: buildYAxisDomain(data),
  };
};
